var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.75C0 37.3185 37.4315 63.75 54 63.75C70.5685 63.75 80 46.8185 80 30.25C80 13.6815 66.5685 0.25 50 0.25C33.4315 0.25 0 4.18146 0 20.75Z",
    fill: "#FFE5E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_6521)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8189 30.3262C34.3246 30.3262 35.5462 31.5779 35.5462 33.1207V36.381C35.5462 37.9238 34.3246 39.1755 32.8189 39.1755H31.0007C29.495 39.1755 28.2734 37.9238 28.2734 36.381V33.1207C28.2734 31.5779 29.495 30.3262 31.0007 30.3262H32.8189ZM41.9098 26.1346C43.4166 26.1346 44.6371 27.3863 44.6371 28.9291V36.381C44.6371 37.9238 43.4166 39.1755 41.9098 39.1755H40.0916C38.5859 39.1755 37.3643 37.9238 37.3643 36.381V28.9291C37.3643 27.3863 38.5859 26.1346 40.0916 26.1346H41.9098ZM51.0007 20.5457C52.5064 20.5457 53.728 21.7974 53.728 23.3402V36.381C53.728 37.9238 52.5064 39.1755 51.0007 39.1755H49.1825C47.6757 39.1755 46.4553 37.9238 46.4553 36.381V23.3402C46.4553 21.7974 47.6757 20.5457 49.1825 20.5457H51.0007ZM51.728 16.3005C51.7212 16.3063 51.7155 16.3121 51.7087 16.3179C46.9258 20.9185 42.6212 25.4919 29.2246 26.1336C28.7234 26.1581 28.2973 25.7599 28.2746 25.2464C28.2507 24.7329 28.6382 24.2962 29.1405 24.273C41.5327 23.6791 45.7212 19.535 50.1282 15.2842L49.31 15.4029C48.8123 15.4739 48.352 15.1188 48.2827 14.61C48.2123 14.1 48.5589 13.6296 49.0554 13.5574L52.2066 13.1033C52.7043 13.0311 53.1634 13.3863 53.2338 13.8951L53.677 17.1238C53.7474 17.6327 53.4009 18.1042 52.9031 18.1764C52.4065 18.2474 51.9463 17.8935 51.877 17.3835L51.728 16.3005Z",
    fill: "#FE5F55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_6521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    fill: "white",
    transform: "translate(25 8.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.f763c760ed96f39548e1159f49a27c07.svg";
export { ForwardRef as ReactComponent };